<div class="row mx-0 w-auto">
    <div class="col-1 pl-0">
        <span class="material-icons-outlined">
            check_circle
        </span>
    </div>
    <div class="col-10 px-0 pl-1 pt-1" style="line-height: 18px;">
        <p class="mb-0"><span> {{snackbarMessage}}</span> </p>
    </div>
    <div class="col-1 pr-0" *ngIf="isUndoAvailble">
        <button mat-button type="button" (click)="onUndoClick(true)" class="px-1" style="float: right;">UNDO</button>
    </div>
</div>